import CancelIcon from "@mui/icons-material/Cancel";
import {
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useMemo, useState } from "react";
import { MenuProps } from "../../utils/constants";

const ALLVALUE = {
  code: "ALL",
  name: "Tất cả",
  id: "ALL",
  ma: "ALL",
  key: "ALL",
};
function SelectCustomer(props) {
  const {
    keyValue,
    label,
    onChange,
    option,
    state,
    labelName,
    unicode,
    multiple = false,
    isHiddenLabel = false,
  } = props;
  const [valueState, setValueState] = useState();
  const dictOption = useMemo(() => {
    let dict = {};
    if (Array.isArray(option) && option.length > 0) {
      option?.forEach((item) => {
        dict[item[unicode]] = item;
      });
    }
    return dict;
  }, [option]);

  useEffect(() => {
    setValueState(state);
  }, [state]);
  const handleChangeMultiple = (e) => {
    let { value } = e.target;
    if (value?.length > 1 && value[0] == ALLVALUE[unicode]) value?.shift();
    else if (
      (value?.length > 1 && value[value?.length - 1] == ALLVALUE[unicode]) ||
      value?.length == 0
    )
      value = [ALLVALUE[unicode]];
    setValueState(value);
    onChange?.(e, value);
  };
  const handleChangeSelect = (e) => {
    let { value } = e.target;
    setValueState(value);
    onChange?.(e, value);
  };
  const handleToDelete = (value) => (e) => {
    let newArr = valueState.filter((item) => item !== value);
    if (newArr?.length == 0) {
      newArr = [ALLVALUE[unicode]];
    }
    setValueState(newArr);
    onChange?.(e, newArr);
  };
  return multiple ? (
    <FormControl fullWidth size="small">
      {!isHiddenLabel && (
        <InputLabel id={`label-${keyValue}`}>{label}</InputLabel>
      )}
      <Select
        sx={{ padding: "0.7rem" }}
        labelId={`label-${keyValue}`}
        value={
          option?.length > 0 && valueState
            ? valueState || [ALLVALUE[unicode]]
            : [ALLVALUE[unicode]]
        }
        defaultValue={[ALLVALUE[unicode]]}
        label={!isHiddenLabel ? label : ""}
        MenuProps={MenuProps}
        onChange={handleChangeMultiple}
        multiple
        renderValue={(selected) => {
          return (
            <Stack gap={1} direction="row" flexWrap="wrap">
              {selected?.includes(ALLVALUE[unicode]) ? (
                <Typography fontSize="0.75rem">Tất cả</Typography>
              ) : (
                Object.values(dictOption)?.length > 0 &&
                selected.map((value) => (
                  <Chip
                    key={value}
                    label={dictOption[value]?.[labelName]}
                    onDelete={handleToDelete(value)}
                    deleteIcon={
                      <CancelIcon
                        onMouseDown={(event) => event.stopPropagation()}
                      />
                    }
                    sx={{
                      fontSize: "0.75rem",
                      height: "1.25rem",
                    }}
                  />
                ))
              )}
            </Stack>
          );
        }}
      >
        <MenuItem value={ALLVALUE[unicode]}>Tất cả</MenuItem>
        {option &&
          option?.length > 0 &&
          option.map((item) => (
            <MenuItem key={item?.[unicode]} value={item?.[unicode]}>
              {item?.[labelName]}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  ) : (
    <FormControl fullWidth size="small">
      {!isHiddenLabel && (
        <InputLabel id={`label-${keyValue}`}>{label}</InputLabel>
      )}
      <Select
        sx={{ padding: "0.7rem" }}
        labelId={`label-${keyValue}`}
        value={
          option?.length > 0 && valueState
            ? valueState || ALLVALUE[unicode]
            : ALLVALUE[unicode]
        }
        defaultValue={ALLVALUE[unicode]}
        label={!isHiddenLabel ? label : ""}
        MenuProps={MenuProps}
        onChange={handleChangeSelect}
      >
        <MenuItem value={ALLVALUE[unicode]}>Tất cả</MenuItem>
        {option &&
          option?.length > 0 &&
          option.map((item) => (
            <MenuItem key={item?.[unicode]} value={item?.[unicode]}>
              {item?.[labelName]}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
}
SelectCustomer.propTypes = {
  keyValue: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  option: PropTypes.array,
  state: PropTypes.any,
  labelName: PropTypes.string,
  unicode: PropTypes.string,
  multiple: PropTypes.bool,
  isHiddenLabel: PropTypes.bool,
};

export default SelectCustomer;
